module.exports = __webpack_public_path__ + "img/8.6d28e9e3.jpg";